import { ApplicationSection } from "@prisma/client";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";

const rollback = async (
  applicationId: string,
  refereeId: string
): Promise<ApplicationSection> => {
  return await axios
    .post(
      `${process.env.NEXT_PUBLIC_API_URL}/application/${applicationId}/referee/details/rollback`,
      { refereeId }
    )
    .then((res) => res.data);
};

export const useRollbackMutation = () =>
  useMutation<
    ApplicationSection,
    null,
    { applicationId: string; refereeId: string },
    () => void
  >(({ applicationId, refereeId }) => rollback(applicationId, refereeId));
